export default __webpack_public_path__ + "static/media/schedule-sep-balls.753a9159.svg";